// @ts-nocheck

import axios from 'axios';
import api from './ApiService';

export async function getFunctionList(params) {
    const response = await api.get(`/function/list`);
    return response.data.data;
}

export async function executeFunction(body) {
    const response = await api.post(`/function/execute`, body);
    return response.data;
}

export async function executeFunctionSequence(body) {
    const response = await api.post(`/function/execute-sequence`, body);
    return response.data;
}